import React from 'react';
import { FormattedMessage } from 'react-intl';
import { format } from '../../../lib/money';

const ContributionsProgress = ({ committedAmount, totalAmount }) => (
  <div className="row align-items-center mb-4">
    <div className="col-3 text-center">
      <i className="fa fa-dollar round-border medium cool-grey" />
    </div>
    <div className="col-9">
      <h4 className="mb-0">
        <FormattedMessage
          id="contributionsProgress.contributionsMade"
          defaultMessage="Contributions made"
        />
      </h4>
      <span className="contribution-muted-text">
        {format(committedAmount)}
        {' '}
        <FormattedMessage
          id="contributionsProgress.contributionsMade.of"
          defaultMessage="of"
        />
        {' '}
        {format(totalAmount)}
      </span>
    </div>
  </div>
);

export default ContributionsProgress;



// WEBPACK FOOTER //
// ./src/desktop/components/purchase-dashboard/group-summary/contributions-progress.js